import { render, staticRenderFns } from "./FormNumberInput.vue?vue&type=template&id=063ff016&scoped=true&"
import script from "./FormNumberInput.vue?vue&type=script&lang=js&"
export * from "./FormNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./FormNumberInput.vue?vue&type=style&index=0&id=063ff016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ff016",
  null
  
)

export default component.exports